import {InitPage} from "../index";

class AccessLog {
    constructor() {
        this.init();
        $('.view_details').on('click', function (e) {
            e.preventDefault();
            var details = $(this).data('details');

            $('#details_box').text(JSON.stringify(details, null, 2));
            $("#view_details_form").modal('show');
          });

          $('.select_tag_gray').on('change', function(e){
            $('#search_form').submit();
          });
    }

    init() {

    }
}

export function LoadPage() {
    InitPage("users access_logs", () => {
        const c = new AccessLog();
    });
}
